"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscriber = void 0;
const react_1 = __importDefault(require("react"));
const react_2 = require("react");
/**
 * Fires form subscription handlers every time it is rerendered.
 */
function Subscriber({ fireSubscriptions, }) {
    /**
     * Fires subscription handlers on every change.
     */
    (0, react_2.useEffect)(() => {
        fireSubscriptions();
    });
    return react_1.default.createElement(react_1.default.Fragment, null);
}
exports.Subscriber = Subscriber;
//# sourceMappingURL=subscriber.js.map